import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=f31f4110&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=f31f4110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31f4110",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f31f4110')) {
      api.createRecord('f31f4110', component.options)
    } else {
      api.reload('f31f4110', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=f31f4110&scoped=true&", function () {
      api.rerender('f31f4110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z8z8a6v8x0MO/JS/comp/Voucher.vue"
export default component.exports